// Add flags you want to use on the project

export const flagsAXP = [
  'flagAxpEmailBuilderComponentsRedesign',
  'flagBuilderLazyLoadSections',
  'flagBuilderPageGlobalStorage',
  'flagBuilderRemoveColumnBackground',
  'flagBuilderUploadDownloadZip',
  'flagBuilderUploadVideo',
  'flagBuilderWeightLimitation',
] as const;

export const flagsIM = [
  'flagImAddAttachment',
  'flagImCreateChannelApi',
  'flagImCreateConversation',
  'flagImEmojiPicker',
  'flagImCustomEmojiReactions',
] as const;

export default [
  ...flagsAXP,
  ...flagsIM,
  'flagActivateFrontMonitoringDatadog',
  'flagAxpCampaignsCkDeprecation',
  'flagAxpEngagementScoringImprovements',
  'flagAxpNewUserIndex',
  'flagAxpPlanhatIntegration',
  'flagBraintree3DSecureSca',
  'flagCurrentSessionContext',
  'flagDsIsolationNewsDetailPage',
  'flagEvAblyInactivityTracker',
  'flagEvBlockContentUploadCkEditor',
  'flagEvEventsBoRevamp',
  'flagEvEventsValidations',
  'flagEvGsMembershipLogo',
  'flagEvImproveSoldOutEventsFo',
  'flagEvMembershipFoPagination',
  'flagEvMentoringAdminMatch',
  'flagEvNewsRevamp',
  'flagEvMessagingReactQuery',
  'flagEvOrderSummaryDsEvents',
  'flagEvOrderSummaryDsMemberships',
  'flagEvPaymentPageDonations',
  'flagEvPaymentPageEvents',
  'flagEvPaymentPageMemberships',
  'flagEvPaymentsMovePromocode',
  'flagEvStripeCobrandedCards',
  'flagEvStripeDirectChargeForAllCC',
  'flagEvSuperAdminReadOnly',
  'flagEvTinyMce',
  'flagEvTinyMceOnlineAlerts',
  'flagEvTinyMceOrganizations',
  'flagEvUserPicturesToGlobalStorage',
  'flagEvVirusScanning',
  'flagGoogleMapsComponent',
  'flagHivehackNotifyPeople',
  'flagLiveFeedDesignImprovements2',
  'flagMobileAppsBoOptionalAndroidServiceAccountJson',
  'flagMobileNewDialog',
  'flagNewAnalyticsMvp',
  'flagProfileCustomHeader',
  'flagRequestUserAccountDeletion',
  'flagSuEmailSecurity',
  'flagSuNotifSignin',
  'flagUeMobileCaretFooter',
  'flagUeNewOutdatedBrowserDetection',
  'flagUeSearchDeactivateGlobal',
  'flagUjAblyInternalNotifications',
  'flagUjAnchoringComments',
  'flagUjDynamicComponentsPerfUsersTopicsDiscussions',
  'flagUjNotificationsNotifyImprovement',
  'flagUjSearchLocationAnonymous',
  'flagUjAiContentRecommendation',
  'flagUjbBiggerBadgeSize',
  'flagUjbDynamicComponentsPerf',
  'flagUjbGroupHeaderRedesign',
  'flagUjbLfPagination',
  'flagUjbPerfNetworkMenuPages',
  'flagUjbTripGermanTransportation',
  'flagUseWhitelabelCustomCertificate',
] as const;
